import { combineReducers, Reducer } from "redux";

import { IFavoriteFormsLoadedAction, IFavoriteFormUpdatedAction } from "@multiweb/reactCore/bridge";
import { FavoriteMenuItems, IFavoriteItemsState } from "./types";

export const favoriteForms: Reducer<FavoriteMenuItems> = (state: FavoriteMenuItems = [], action) => {
    if (action instanceof IFavoriteFormsLoadedAction) {
        // v akci mohou přijít duplicitní kódy, je nutné se jich tu explicitně zbavit
        return action.payload.favoriteForms.map(f => ({
            formId: f.menuId,
            profileId:f.profileId,
        }));
    } else if (action instanceof IFavoriteFormUpdatedAction) {
        const { menuId, isFavorite, profile } = action.payload;
        if (isFavorite) {
            return state.some(favoriteItem => favoriteItem.formId === menuId && favoriteItem.profileId == profile?.id) ? state : [...state, { formId: menuId, profileId: profile?.id }];
        } else {
            return state.some(favoriteItem => favoriteItem.formId === menuId && favoriteItem.profileId == profile?.id) ? state.filter(favoriteItem => favoriteItem.formId !== menuId || favoriteItem.profileId != profile?.id) : state;
        }
    }
    return state;
};

export const reducer: Reducer<IFavoriteItemsState> = combineReducers({
    favoriteForms,
});
